var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavigateNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m375.59 802.153-35.794-35.794L530.565 575.59 339.796 384.564l35.794-35.794 226.563 226.82L375.59 802.153Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigateNext);
export default __webpack_public_path__ + "static/media/icon-navigate-next.1e24a7c1e4f70d0651579aa2eca88d02.svg";
export { ForwardRef as ReactComponent };